import { objectSelector } from "theme/utils";
import {
  FETCH_CHECKOUT_REJECTED,
  FETCH_CHECKOUT_FULFILLED,
  FETCH_CITIES_FULFILLED,
  FETCH_TOWNSHIPS_FULFILLED,
  FETCH_DISTRICTS_FULFILLED,
  SEND_ADDRESS_REJECTED,
  FETCH_CHECKOUT_PENDING,
  FETCH_CHECKOUT_MODAL_PENDING,
  PAGES,
  FETCH_CASH_REGISTER_REJECTED,
  ADD_GIFT_BOX,
  REMOVE_GIFT_BOX,
  SEND_QRCODE_EMAIL_FULFILLED,
  SEND_QRCODE_EMAIL_REJECTED,
  SET_FALSE_THANK_YOU_PAGE,
  FETCH_GUEST_CHECKOUT_FULFILLED,
  FETCH_GUEST_CHECKOUT_PENDING,
  FETCH_GUEST_CHECKOUT_REJECTED,
  CLEAR_GUEST_CHECKOUT,
  CLEAR_CUSTOMER_CHECKOUT,
  CLEAR_CHECKOUT_REDIRECT,
  FETCH_COUNTRIES_FULFILLED,
} from "../constants/checkout";

const initialPreOrder = {
  billing_address: null,
  billing_and_shipping_same: null,
  currency_type_label: null,
  delivery_option: null,
  delivery_range: null,
  gift_box: null,
  installment: null,
  is_guest: null,
  is_post_order: null,
  loyalty_money: null,
  notifications: null,
  payment_choice: null,
  payment_option: null,
  phone_number: null,
  redirect_to_three_d: null,
  retail_store: null,
  shipping_address: null,
  shipping_amount: null,
  shipping_option: null,
  total_amount: null,
  total_amount_with_interest: null,
  unpaid_amount: null,
  user_email: null,
  user_phone_number: null,
};

const initialState = {
  pending: true,
  modalPending: false,
  guest: {
    pending: false,
    success: false,
    error: null,
  },
  error: {
    agreement: null,
    userEmail: null,
    non_field_errors: null,
  },
  preOrder: initialPreOrder,
  context: {
    retail_stores: [],
    is_user_logged_in: false,
    delivery_options: [],
    addresses: [],
    country: {},
    shipping_options: [],
    payment_options: [],
    installment_options: [],
    get_barcode: false,
    countries: [],
    cities: [],
    townships: [],
    districts: [],
    barcode: null,
    ask_to_cash: false,
    number: 0,
    thankyou: false,
    qrUrl: null,
    orderStatusUrl: null,
    is_qrcode_email_send: null,
    redirect: null,
    bank_accounts: [],
    order_number: null,
  },
};

export const checkout = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CHECKOUT_PENDING:
      return {
        ...state,
        pending: true,
      };

    case FETCH_CHECKOUT_MODAL_PENDING:
      state.context["get_barcode"] = false;
      state.context["barcode"] = null;
      state.context["ask_to_cash"] = false;

      return {
        ...state,
        context: state.context,
        modalPending: true,
      };

    case FETCH_CHECKOUT_REJECTED:
      return {
        ...state,
        pending: false,
        modalPending: false,
        error: action.error,
      };

    case SEND_ADDRESS_REJECTED:
      const error = action.error.response.data;
      return {
        ...state,
        pending: false,
        modalPending: false,
        error: {
          country: error.country && error.country[0],
          city: error.city && error.city[0],
          township: error.township && error.township[0],
          district: error.district && error.district[0],
          first_name: error.first_name && error.first_name[0],
          last_name: error.last_name && error.last_name[0],
          line: error.line && error.line[0],
          phone_number: error.phone_number && error.phone_number[0],
          title: error.title && error.title[0],
          identity_number: error.identity_number && error.identity_number[0],
        },
      };

    case FETCH_CHECKOUT_FULFILLED:
      const preOrder = action.response.pre_order;
      const contextList = action.response.context_list;

      let validateErrors = {};
      if (action.response.errors) {
        const errors = action.response.errors || {};
        validateErrors = {
          agreement: errors && errors.agreement && errors.agreement[0],
          non_field_errors:
            errors.non_field_errors && errors.non_field_errors[0],
        };
      } else {
        validateErrors = {
          agreement: null,
          non_field_errors: null,
        };
      }

      Array.isArray(contextList) &&
        contextList.forEach((context) => {
          state.context["page_name"] = context.page_name;
          state.context["page_slug"] = context.page_slug;
          switch (context.page_name) {
            case PAGES.indexPage:
              state.context["is_user_logged_in"] =
                context.page_context.is_user_logged_in;
              break;

            case PAGES.deliveryOptionSelectionPage:
              state.context["delivery_options"] =
                context.page_context.delivery_options;
              break;

            case PAGES.addressSelectionPage:
              state.context["addresses"] = context.page_context.addresses;
              state.context["country"] = context.page_context.country;
              break;

            case PAGES.retailStoreSelectionPage:
              state.context["addresses"] = context.page_context.addresses;
              state.context["retail_stores"] =
                context.page_context.retail_stores;
              break;

            case PAGES.shippingOptionSelectionPage:
              // Ayni gun teslimat kaldirildi.
              const manipulated = context.page_context.shipping_options.filter(
                (shipping) =>
                  shipping.slug !== "is-mail" && shipping.slug !== "hoopkapida"
              );
              state.context["shipping_options"] = manipulated;
              break;

            case PAGES.paymentOptionSelectionPage:
              state.context["qrUrl"] = context.page_context.checkout_url;
              state.context["orderStatusUrl"] = context.page_context.status_url;
              state.context["payment_options"] =
                context.page_context.payment_options;
              break;
            case PAGES.fundsTransferChoicePage:
              state.context["bank_accounts"] =
                context.page_context.bank_accounts;
              break;

            case PAGES.redirectionPageCompletePage:
              state.context["redirect"] = context.page_context.redirect_url;
              break;

            case PAGES.cashRegisterPage:
              state.context["get_barcode"] = true;
              break;

            case PAGES.cashRegisterInstallmentSelectionPage:
              state.context["installment_options"] = context.page_context.cards;
              break;

            case PAGES.cashRegisterCompletePage:
              state.context["barcode"] = context.page_context.barcode;
              state.context["number"] = context.page_context.number;
              state.context["ask_to_cash"] = true;
              break;

            case PAGES.thankYouPage:
              state.context["ask_to_cash"] = false;
              state.context["thankyou"] = true;
              state.context["order_number"] = context.page_context.order_number;
              break;

            default:
              break;
          }
        });
      return {
        ...state,
        pending: false,
        modalPending: false,
        preOrder: preOrder || initialPreOrder,
        context: {
          ...state.context,
        },
        qrUrl: state.context.qrUrl,
        orderStatusUrl: state.context.orderStatusUrl,
        error: validateErrors,
      };

    case FETCH_COUNTRIES_FULFILLED:
      state.context["countries"] = action.response.results;
      state.context["cities"] = [];
      state.context["townships"] = [];
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case FETCH_CITIES_FULFILLED:
      state.context["cities"] = action.response.results;
      state.context["townships"] = [];
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case ADD_GIFT_BOX:
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case REMOVE_GIFT_BOX:
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case FETCH_TOWNSHIPS_FULFILLED:
      state.context["townships"] = action.response.results;
      state.context["districts"] = [];
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case FETCH_DISTRICTS_FULFILLED:
      state.context["districts"] = action.response.results;
      return {
        ...state,
        pending: false,
        context: state.context,
        error: {},
      };

    case FETCH_CASH_REGISTER_REJECTED:
      return {
        ...state,
        context: state.context,
        pending: false,
        modalPending: false,
        error: action.error,
      };
    case SEND_QRCODE_EMAIL_FULFILLED:
      state.context["is_qrcode_email_send"] = true;
      return {
        ...state,
        context: state.context,
      };
    case SEND_QRCODE_EMAIL_REJECTED:
      state.context["is_qrcode_email_send"] = false;
      return {
        ...state,
        context: state.context,
      };

    case SET_FALSE_THANK_YOU_PAGE:
      return {
        ...state,
        context: {
          ...state.context,
          thankyou: false,
        },
      };

    case FETCH_GUEST_CHECKOUT_FULFILLED:
      const cntxList = action.response.context_list;

      cntxList &&
        cntxList.forEach((context) => {
          state.context["page_name"] = context.page_name;
          switch (context.page_name) {
            case PAGES.indexPage:
              state.context["is_user_logged_in"] =
                context.page_context.is_user_logged_in;
              break;

            case PAGES.deliveryOptionSelectionPage:
              state.context["delivery_options"] =
                context.page_context.delivery_options;
              break;

            case PAGES.addressSelectionPage:
              state.context["addresses"] = context.page_context.addresses;
              state.context["country"] = context.page_context.country;
              break;

            case PAGES.shippingOptionSelectionPage:
              state.context["shipping_options"] =
                context.page_context.shipping_options;
              break;

            case PAGES.paymentOptionSelectionPage:
              state.context["qrUrl"] = context.page_context.checkout_url;
              state.context["orderStatusUrl"] = context.page_context.status_url;
              state.context["payment_options"] =
                context.page_context.payment_options;
              break;

            case PAGES.fundsTransferChoicePage:
              state.context["bank_accounts"] =
                context.page_context.bank_accounts;
              break;

            case PAGES.redirectionPageCompletePage:
              state.context["redirect"] = context.page_context.redirect_url;
              break;

            default:
              break;
          }
        });

      return {
        ...state,
        context: state.context,
        preOrder: action.response.pre_order,
        guest: {
          pending: false,
          success: true,
          error: objectSelector(action.response.errors, "user_email.0"),
        },
      };

    case FETCH_GUEST_CHECKOUT_PENDING:
      return {
        ...state,
        guest: {
          pending: true,
          success: false,
          error: null,
        },
      };

    case FETCH_GUEST_CHECKOUT_REJECTED:
      return {
        ...state,
        guest: {
          pending: false,
          success: false,
          error: objectSelector(action.response.errors, "user_email.0"),
        },
      };

    case CLEAR_GUEST_CHECKOUT:
      return {
        ...state,
        guest: {
          pending: false,
          success: false,
          error: null,
        },
      };

    case CLEAR_CUSTOMER_CHECKOUT:
      return initialState;

    case CLEAR_CHECKOUT_REDIRECT:
      return {
        ...state,
        context: {
          ...state.context,
          redirect: null,
        },
      };

    // case FETCH_SMS_FULFILLED:
    //   return {
    //     ...state,
    //     context: state.context,
    //     pending: false,
    //     modalPending: false,
    //     error: action.error
    //   }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/checkout.js